<div class="container">
  <div class="logo-container">
    <div class="logo">
        <img width="205px" [src]="'../../../../../assets/Hayrick/logo/'+subdomain+'/logo-light.svg'" alt="Hayrick Logo" />
    </div>
  </div>

  <div class="card">
    <div class="logo-backBtn-container">
      <div class="back-btn-container">
        <div (click)="navBackBtn()" class="back-button">
          <img class="back-arrow-icon" src="../../../../assets//back-arrow.svg" alt="navigate back" />
        </div>
      </div>
    </div>

    <div *ngIf="sharedService.forgotPasscodeIsOTP">
      <div class="text-container">
        <p class="text-2">Two Factor Authentication Pending</p>
        <p class="text-1">{{otpRequestMethod}} has been sent to you with an OTP.</p>
        <p class="text-3">Please submit to continue.</p>
      </div>

      <div class="otp-input-container">
        <ng-otp-input (onInputChange)="onOtpChange($event)" [config]="otpConfig" #ngOtpInput></ng-otp-input>
      </div>

      <div *ngIf="otpTimer > 0; else showOtpResendButton" class="otp-countdown-txt-container">
        <p>Resend OTP in {{ countDownTimer$ | async }} seconds.</p>
      </div>

      <ng-template #showOtpResendButton>
        <div class="resent-otp-mobile-btn">
          <button (click)="resendOtp(1)" class="resend-btn">Resend OTP - WhatsApp</button>
          <button (click)="resendOtp(2)" class="resend-btn">Resend OTP - Mobile</button>
          <button (click)="resendOtp(3)" class="resend-btn">Resend OTP - Email</button>

        </div>
      </ng-template>
    </div>

    <div *ngIf="!sharedService.forgotPasscodeIsOTP" class="email-box-container">
      <div class="email-box">
        <div class="text-container">

          <p class="text-2">Two Factor Authentication Pending</p>
          <p class="text-3">Enter your email address registered with us.</p>
        </div>

        <form [formGroup]="emailForm">
          <div class="email-input-container">
            <div class="p-field">
              <span class="p-float-label">
                <input placeholder="Email" formControlName="email" id="email" class="email-input" type="email" />

              </span>
            </div>
            <span *ngIf="!emailForm.value.email"
              ><label class="error">Enter a valid email</label></span
            >
          </div>
        </form>

        <div class="signinbutton">
          <button [disabled]="!emailForm.valid" (click)="submitEmail()"  class="sign-in-button">SUBMIT</button>
        </div>
      </div>

  </div>
</div>
